import React from "react";
import { testimonials } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Testimonials() {
  const item = testimonials.items[0];

  return (
    <section className="flex flex-col items-center justify-center bg-paper px-6 pt-0 pb-20 sm:pb-28 lg:pb-32">
      <div className="mx-auto w-full max-w-3xl text-center">
        <Reveal>
          <p className="inline-block border-b border-bronze pb-2 font-sans text-[11px] uppercase tracking-[0.3em] text-ink/60">
            {testimonials.kicker}
          </p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-6 font-sans text-xl font-light uppercase tracking-[0.3em] text-ink sm:text-3xl">
            {testimonials.title}
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <blockquote className="mx-auto mt-10 max-w-2xl text-left text-[14px] font-light leading-[1.95] text-ink/60 sm:text-[15px]">
            “{item.quote}”{" "}
            <span className="ml-1 whitespace-nowrap font-sans text-[11px] uppercase tracking-[0.25em] text-bronze-light">
              — {item.author}
            </span>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}
